import { gql } from '@apollo/client'

const UPDATE_CUISINE_TYPE_IMAGE_DETAILS_MUTATION = gql`
  mutation updateCuisineTypeImageDetails(
    $id: ID!
    $data: CuisineTypeImageDetailsInput!
  ) {
    updateCuisineTypeImageDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      imageUrl
    }
  }
`

export default UPDATE_CUISINE_TYPE_IMAGE_DETAILS_MUTATION
